import { useTranslations } from 'next-intl';

import { UiKitButtonBase } from '@/fo/ui/kit/button/base';

import { styles } from './StickyMobileButton.styles';

export interface StickyMobileButtonProps {
  totals: React.ReactNode;
  onClick?: () => void;
  mainButtonText: string;
  visible?: boolean;
}

export function StickyMobileButton({
  totals,
  onClick,
  mainButtonText,
  visible = true
}: StickyMobileButtonProps) {
  const slots = styles({ visible });
  const t = useTranslations();

  return (
    <div className={slots.base()}>
      <div className={slots.content()}>
        <div>
          {t('total')}
          <br />
          {totals}
        </div>
        <UiKitButtonBase
          color="secondary"
          onClick={onClick}
          className={slots.button()}
        >
          {mainButtonText}
        </UiKitButtonBase>
      </div>
    </div>
  );
}
